import {FONTS} from "./ChartFormatUtils";

//----- temperature line gradient -----
export function gradientBorderColor(context) {
    const chart = context.chart;
    const {ctx, chartArea} = chart;

    if (!chartArea) {
        // This case happens on initial chart load
        return;
    }
    return getBorderGradient(ctx, chartArea);
}

let width, height, gradient
function getBorderGradient(ctx, chartArea) {
    const chartWidth = chartArea.right - chartArea.left
    const chartHeight = chartArea.bottom - chartArea.top
    if (!gradient || width !== chartWidth || height !== chartHeight) {
        width = chartWidth;
        height = chartHeight;
        gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top)
        gradient.addColorStop(0, '#5F009E')
        gradient.addColorStop(1, '#FF393D')
    }

    return gradient
}


//----- water level filler gradient -----
export function gradientFiller(context) {
    const chart = context.chart
    const { ctx, chartArea } = chart

    if (!chartArea) {
        return null // Skip gradient creation if chart hasn't been drawn yet
    }

    const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom)
    gradient.addColorStop(0, "rgba(255, 255, 255, 1)")
    gradient.addColorStop(1, "rgba(255, 255, 255, 0)")
    return gradient
}


//----- point style -----

export function pointRadius(ctx) {
    return 0
}

export function pointBorderColor(ctx) {
    return 'white'
}

export function pointBackgroundColor(ctx) {
    return 'rgba(255, 255, 255, 0.5)'
}


//---- tooltip building
export const externalTooltipHandler = (context) => {
    const {chart, tooltip} = context
    const tooltipEl = getOrCreateTooltip(chart)

    if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0
        return
    }

    if (tooltip.body) {
        appendTooltipBody(tooltip, tooltipEl)
    }

    tooltipEl.style.opacity = 1
    tooltipEl.style.padding = '11px'

    // position
    const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas

    const chartArea = chart.chartArea

    let tooltipX
    if (tooltip.caretX + tooltipEl.offsetWidth > chartArea.right) {
        tooltipX = positionX + tooltip.caretX - 195
    } else {
        tooltipX = positionX + tooltip.caretX
    }

    tooltipEl.style.left = tooltipX + 'px'
    tooltipEl.style.top = positionY + tooltip.caretY + 'px'
}

const getOrCreateTooltip = (chart) => {
    let tooltipEl = chart.canvas.parentNode.querySelector('div.chart-tooltip')

    if (!tooltipEl) {
        tooltipEl = document.createElement('div')
        tooltipEl.classList.add('chart-tooltip')
        tooltipEl.style.background = 'linear-gradient(180deg, #73C6FF 0%, #3AA9F5 100%)'
        tooltipEl.style.borderRadius = '8px'
        tooltipEl.style.border = 'solid 1px rgba(255, 255, 255, 0.6)'
        tooltipEl.style.position = 'absolute'

        const parentDiv = document.createElement('div')

        tooltipEl.appendChild(parentDiv)
        chart.canvas.parentNode.appendChild(tooltipEl)
    }

    return tooltipEl
}

function appendTooltipBody(tooltipObj, tooltipEl) {
    const parentDiv = document.createElement('div')
    parentDiv.style.fontSize = `${FONTS.text.size }px`
    parentDiv.style.fontWeight = FONTS.text.weight
    parentDiv.style.display = 'flex'
    parentDiv.style.flexDirection = 'column'
    parentDiv.style.gap = '8px'

    //---- setting title ----
    const titleDiv = document.createElement('div');
    titleDiv.style.fontSize = `${FONTS.title.size}px`;
    titleDiv.style.fontWeight = FONTS.title.weight;
    titleDiv.style.textAlign = 'left';
    const titleNode = document.createTextNode(tooltipObj.title);
    titleDiv.appendChild(titleNode);
    parentDiv.appendChild(titleDiv)

    //---- setting body lines ----
    tooltipObj.body
        .map(b => b.lines)
        .reverse()
        .forEach((value, i) => appendTooltipBodyLine(tooltipObj, parentDiv, JSON.parse(value[0]), i));

    const tableRoot = tooltipEl.querySelector('div');
    while (tableRoot.firstChild) {
        tableRoot.firstChild.remove();
    }

    tableRoot.appendChild(parentDiv);
}

function appendTooltipBodyLine(tooltip, parentDiv, valueObj, i) {
    const row = document.createElement('div')
    row.style.display = 'flex'
    row.style.alignItems = 'center'
    row.style.gap = '10px'

    const colorBox = createColorBox(i)
    const valueName = createTextDiv(valueObj.name + ': ')
    valueName.style.textAlign = 'left'
    valueName.style.width = '90px'

    const valueNumber = createTextDiv(valueObj.value)
    valueNumber.style.fontWeight = FONTS.title.weight

    row.appendChild(colorBox)
    row.appendChild(valueName)
    row.appendChild(valueNumber)
    parentDiv.appendChild(row)
}

function createTextDiv(value) {
    const textDiv = document.createElement('div')
    textDiv.appendChild(document.createTextNode((value)))
    return textDiv
}

const BOX_COLORS = [
    'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.1) 100%)',
    'linear-gradient(180deg, #FF393D 0%, #5F009E 100%)',
]

function createColorBox(i) {
    const div = document.createElement('div')
    div.style.background = BOX_COLORS[i]
    div.style.height = '16px'
    div.style.width = '16px'
    div.style.borderRadius = '2px'
    return div
}